export default __webpack_public_path__ + "static/media/choix-mission.2ce584d9.mp4";